import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sidebarCollapsed: localStorage.getItem('sidebarCollapsed') === 'true',
  // Session-only: each page remounts DashboardLayout/Sidebar, so this lives in Redux.
  betaExpanded: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
      localStorage.setItem('sidebarCollapsed', state.sidebarCollapsed);
    },
    setSidebarCollapsed: (state, action) => {
      state.sidebarCollapsed = action.payload;
      localStorage.setItem('sidebarCollapsed', state.sidebarCollapsed);
    },
    setBetaExpanded: (state, action) => {
      state.betaExpanded = action.payload;
    },
  },
});

export const { toggleSidebar, setSidebarCollapsed, setBetaExpanded } = uiSlice.actions;
export default uiSlice.reducer;
